import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectModals } from '~/selectors';
import { closeModal, setModal } from '~/slice';
import { openModal } from '~/thunks';
import sanitize from './sanitize';

export default ({ modalId, trigger }) => {
  const dispatch = useDispatch();
  const modals = useSelector(selectModals);
  const config = useMemo(() => modals[modalId], [modalId, modals]);

  const open = useCallback(
    (data) => dispatch(openModal({ modal: { modalId, trigger, ...sanitize(data) }, trigger: `useModal@${trigger}` })),
    [dispatch, trigger, modalId]
  );
  const update = useCallback(
    (data) => dispatch(setModal({ modal: { modalId, trigger, ...sanitize(data) }, trigger: `useModal@${trigger}` })),
    [dispatch, trigger, modalId]
  );
  const close = useCallback(
    (data) => dispatch(closeModal({ modal: { modalId, trigger, ...sanitize(data) }, trigger: `useModal@${trigger}` })),
    [dispatch, trigger, modalId]
  );

  return useMemo(
    () => ({
      ...config,
      visible: !!config,
      open,
      update,
      close,
    }),
    [config, open, update, close]
  );
};
